export default __webpack_public_path__ + "static/media/white_noise_gif.2290dc38.gif";